import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { playerStatsNavSelector } from 'store/modules/mc-player-stats/selectors';
import { setNavItem } from 'common/store/modules/mc-player-stats/init';

export const TeamsNavItem = ({
    homePid,
    awayPid,
    homeNickname,
    awayNickname
}) => {
    const dispatch = useDispatch();
    const nav = useSelector(playerStatsNavSelector);

    // Use full name with nickname as fallback
    const homeLabel =
        PULSE.app.common.team.getTeamName(homePid) || homeNickname;
    const awayLabel =
        PULSE.app.common.team.getTeamName(awayPid) || awayNickname;

    return (
        <Select
            items={['Both', homeLabel, awayLabel]}
            initialSelectedItem={nav.teams}
            activeItem={nav.teams}
            label={getTranslation('label.teams')}
            onSelectedItemChange={({ selectedItem }) => {
                let teamPid = null;
                if (selectedItem === homeLabel) {
                    teamPid = homePid;
                } else if (selectedItem === awayLabel) {
                    teamPid = awayPid;
                }

                // teamPid used to filter Player Stats Table rows
                dispatch(
                    setNavItem({
                        navItem: {
                            teams: selectedItem,
                            teamPid
                        }
                    })
                );
            }}
        />
    );
};

TeamsNavItem.propTypes = {
    homePid: PropTypes.string.isRequired,
    awayPid: PropTypes.string.isRequired,
    homeNickname: PropTypes.string.isRequired,
    awayNickname: PropTypes.string.isRequired
};
